import api from './api';

const contactService = {
  getContacts: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.search) query.set('search', params.search);
    if (params.page) query.set('page', params.page);
    if (params.limit) query.set('limit', params.limit);
    if (params.source && params.source !== 'all') query.set('source', params.source);
    const res = await api.get(`/contacts?${query.toString()}`);
    return res.data;
  },

  getAllContactIds: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.search) query.set('search', params.search);
    if (params.source && params.source !== 'all') query.set('source', params.source);
    const res = await api.get(`/contacts/all?${query.toString()}`);
    return res.data;
  },

  createContact: async (data) => {
    const res = await api.post('/contacts', data);
    return res.data;
  },

  updateContact: async (id, data) => {
    const res = await api.put(`/contacts/${id}`, data);
    return res.data;
  },

  deleteContact: async (id) => {
    const res = await api.delete(`/contacts/${id}`);
    return res.data;
  },

  importContacts: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post('/contacts/import', formData);
    return res.data;
  },

  exportContacts: async () => {
    const res = await api.get('/contacts/export', { responseType: 'blob' });
    return res.data;
  },

  sendEmails: async (recipients, subject, message) => {
    const res = await api.post('/contacts/send-email', { recipients, subject, message });
    return res.data;
  }
};

export default contactService;
